import { render, staticRenderFns } from "./viewLuckWheel.vue?vue&type=template&id=2cbd474d&scoped=true"
import script from "./viewLuckWheel.vue?vue&type=script&lang=js"
export * from "./viewLuckWheel.vue?vue&type=script&lang=js"
import style0 from "./viewLuckWheel.vue?vue&type=style&index=0&id=2cbd474d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd474d",
  null
  
)

export default component.exports